<template>
    <ul class="my-tab">
        <li :class="{'active':activeIndex == index}" v-for="(item, index) in tabData" :key="index" @click="choose(index)" >{{item}}</li>
    </ul>
</template>
<script>
export default {
    data() {
        return {
            activeIndex: 0
        }
    },
    props: [
        'tabData'
    ],
    methods: {
        choose(i) {
            this.activeIndex = i
            this.$emit('tab_index', i)
        }
    },
}
</script>
<style scoped>
    li {
        list-style: none;
    }
    .my-tab {
        width: 100%;
        height: 70px;
        padding-left: 20px;
        background: #f1f1f1;
    }
    .my-tab li {
        float: left;
        margin: 20px 10px 0;
        width: 100px;
        height: 30px;
        font-size: 16px;
        line-height: 30px;
        text-align: center;
        color: #6f6f6f;
        cursor: pointer;
    }
    li.active {
        border-radius: 4px;
        color: #fff;
        background: #E6BE8A;
    }
</style>



// WEBPACK FOOTER //
// src/components/myTab.vue